import React, {useContext, useEffect, useState} from 'react';
import {Alert, Button, Flex} from 'antd';
import {Splide, SplideSlide} from '@splidejs/react-splide';
import {FiCopy, FiTrash2} from 'react-icons/fi';
import {Switch, Toggle} from '../../../../components';
import rectangleObst from "../../../../assets/img/obstruction-types/Obs-Rectangle.png";
import circleObst from "../../../../assets/img/obstruction-types/Obs-Circle.png";
import polygonObst from "../../../../assets/img/obstruction-types/Obs-Polygon.png";
import {useCurrentUser} from '../../../../contexts/UserContext';
import {FOOT, INCH, METER, UnitContext} from '../../../../contexts/UnitContext';
import {useViewerStore} from "../../../../store/store";
import {ArrowsOutCardinal, Plus} from "@phosphor-icons/react";
import SliderInput from "../../../../components/Pure-UI-Components/SliderInput/SliderInput";
import {GetRoundNum} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/Common";
import {
    SetupObstUI,
} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/TransControl";
import {SLIDER_PROPERTIES_SETTINGS} from "../../../../Constants";
import {
    resetVirObsToDefault
} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/PushControls";
import {registerRef} from "../../../../helpers/storeHelpers";
import { AlertType, HideObjectType, MeshType, SelectType, EditAction } from '../../../../@types/enums';
import { ObstructionGroup, ObstructionMesh, SelectMethod } from '../../../../@types/types';


const ObstructionProperties: React.FC = () => {
    const {user, hasCapability} = useCurrentUser();

    const sceneViewer = useViewerStore(state => state.sceneViewer);

    const {obstructionUnit, convertTypeQuantityToUnit, convertQuantityToUnit, renderUnit} = useContext(UnitContext);

    const selectedObstruction = useViewerStore((state) => state.selectedObstruction);
    const obstUpdated = useViewerStore((state) => state.obstUpdated);

    const [cubeHeight, setCubeHeight] = useState(GetRoundNum(convertTypeQuantityToUnit(MeshType.Obst, selectedObstruction?.height ?? 0, METER), 2));
    const [length, setLength] = useState(GetRoundNum(convertTypeQuantityToUnit(MeshType.Obst, selectedObstruction?.length ?? 0, METER), 2));
    const [width, setWidth] = useState(GetRoundNum(convertTypeQuantityToUnit(MeshType.Obst, selectedObstruction?.width ?? 0, METER), 2));
    const [sides, setSides] = useState(selectedObstruction?.sides ?? 0);
    const [diameter, setDiameter] = useState(GetRoundNum(convertTypeQuantityToUnit(MeshType.Obst, selectedObstruction?.diameter ?? 0, METER), 2));
    const [radius, setRadius] = useState(GetRoundNum(convertTypeQuantityToUnit(MeshType.Obst, selectedObstruction?.radius ?? 0, METER), 2));


    const isHideAllGhostObstructions = useViewerStore(state => state.isHideAllGhostObstructions);

    const isAddObstructionActive = useViewerStore(state => state.isAddObstructionActive);
    const isMoveObstructionActive = useViewerStore(state => state.isMoveObstructionActive);


    useEffect(() => {
        if (user?.user_Id) {
            setCubeHeight(GetRoundNum(convertTypeQuantityToUnit(MeshType.Obst, selectedObstruction?.height ?? 0, METER), 2));
            setLength(GetRoundNum(convertTypeQuantityToUnit(MeshType.Obst, selectedObstruction?.length ?? 0, METER), 2));
            setWidth(GetRoundNum(convertTypeQuantityToUnit(MeshType.Obst, selectedObstruction?.width ?? 0, METER), 2));
            setSides(selectedObstruction?.sides ?? 0);
            setDiameter(GetRoundNum(convertTypeQuantityToUnit(MeshType.Obst, selectedObstruction?.diameter ?? 0, METER), 2));
            setRadius(GetRoundNum(convertTypeQuantityToUnit(MeshType.Obst, selectedObstruction?.radius ?? 0, METER), 2));
        }
    }, [selectedObstruction, obstructionUnit, user, obstUpdated]);

    const changeCubeHeight = (value: number) => {
        sceneViewer.setObstHeight(convertQuantityToUnit(value, obstructionUnit, METER));
        setCubeHeight(value);
    };

    const changeLength = (value: number) => {
        sceneViewer.setObstLength(convertQuantityToUnit(value, obstructionUnit, METER));
        setLength(value);
    };

    const changeWidth = (value: number) => {
        sceneViewer.setObstWidth(convertQuantityToUnit(value, obstructionUnit, METER));
        setWidth(value);
    };

    const changeSides = (value: number) => {
        sceneViewer.setObstSides(value);
        setSides(value);
    }

    const changeDiameter = (value: number) => {
        sceneViewer.setObstDiameter(convertQuantityToUnit(value, obstructionUnit, METER));
        setDiameter(value);
    };

    const changeRadius = (value: number) => {
        sceneViewer.setObstRadius(convertQuantityToUnit(value, obstructionUnit, METER));
        setRadius(value);
    };

    const obstructions = [
        {
            id: 1,
            img: rectangleObst,
            alt: "Rectangle Obstruction"
        },
        {
            id: 2,
            img: polygonObst,
            alt: "Polygon Obstruction"
        },
        {
            id: 3,
            img: circleObst,
            alt: "Circle Obstruction"
        }
    ];

    let rangeCubeHeight;
    let rangeCubeWidth;
    let rangeCubeLength;
    const rangePolygonSides = SLIDER_PROPERTIES_SETTINGS.OBSTRUCTION_PROPERTIES.POLYGON_SIDES;

    let rangeCircleRadius;

    switch (obstructionUnit) {
        case INCH:
            rangeCubeHeight = SLIDER_PROPERTIES_SETTINGS.OBSTRUCTION_PROPERTIES.CUBE_HEIGHT.INCH;
            rangeCubeWidth = SLIDER_PROPERTIES_SETTINGS.OBSTRUCTION_PROPERTIES.CUBE_WIDTH.INCH;
            rangeCubeLength = SLIDER_PROPERTIES_SETTINGS.OBSTRUCTION_PROPERTIES.CUBE_LENGTH.INCH;
            rangeCircleRadius = SLIDER_PROPERTIES_SETTINGS.OBSTRUCTION_PROPERTIES.CIRCLE_RADIUS.INCH;
            break;
        case FOOT:
            rangeCubeHeight = SLIDER_PROPERTIES_SETTINGS.OBSTRUCTION_PROPERTIES.CUBE_HEIGHT.FOOT;
            rangeCubeWidth = SLIDER_PROPERTIES_SETTINGS.OBSTRUCTION_PROPERTIES.CUBE_WIDTH.FOOT;
            rangeCubeLength = SLIDER_PROPERTIES_SETTINGS.OBSTRUCTION_PROPERTIES.CUBE_LENGTH.FOOT;
            rangeCircleRadius = SLIDER_PROPERTIES_SETTINGS.OBSTRUCTION_PROPERTIES.CIRCLE_RADIUS.FOOT;
            break;
        case FOOT:
            rangeCubeHeight = SLIDER_PROPERTIES_SETTINGS.OBSTRUCTION_PROPERTIES.CUBE_HEIGHT.FOOT;
            rangeCubeWidth = SLIDER_PROPERTIES_SETTINGS.OBSTRUCTION_PROPERTIES.CUBE_WIDTH.FOOT;
            rangeCubeLength = SLIDER_PROPERTIES_SETTINGS.OBSTRUCTION_PROPERTIES.CUBE_LENGTH.FOOT;
            rangeCircleRadius = SLIDER_PROPERTIES_SETTINGS.OBSTRUCTION_PROPERTIES.CIRCLE_RADIUS.FOOT;
            break;
    }

    useEffect(() => {
        if (isAddObstructionActive === false) {
            SetupObstUI(sceneViewer)
        }
    }, [isAddObstructionActive]);

    useEffect(() => {
        if (isMoveObstructionActive === false) {
            document.body.style.cursor = "default";
            SetupObstUI(sceneViewer)
        }
    }, [isMoveObstructionActive]);

    const selectMethod = (method: SelectMethod) => {

        sceneViewer.selectType = SelectType.obst;

        if (method === 'move') {
            useViewerStore.setState({isAddObstructionActive: false});

            sceneViewer.setPushMode(false);

            let isDefaultPolygonObstSelected = null
            sceneViewer.obstGroup.children.forEach((group: any) => {
                const inGroup = group.children[0].children[0], obstMesh = inGroup.children[0] as ObstructionMesh, obstFrame = inGroup.children[1];

                if(obstFrame.visible && obstMesh.shapeNum === 4){
                    isDefaultPolygonObstSelected = true;
                }
            });

            if(isDefaultPolygonObstSelected){
                sceneViewer.viewerAlert({
                    title: "Cannot Move Default Polygon Obstructions",
                    messageType: AlertType.warning,
                    isCloseAfterDisplay: true,
                    autoCloseSeconds: 2000,
                });
                return;
            }

            useViewerStore.setState({isMoveObstructionActive: !isMoveObstructionActive});

            sceneViewer.setMoveMode(!isMoveObstructionActive);

            document.body.style.cursor = "move";
        }

        if (method === 'add') {
            useViewerStore.setState({isMoveObstructionActive: false});

            sceneViewer.setMoveMode(false);

            resetVirObsToDefault(sceneViewer);

            useViewerStore.setState({isAddObstructionActive: !isAddObstructionActive});

            sceneViewer.setPushMode(!isAddObstructionActive);

        }
    }


    const setDeleteObst = (e: React.MouseEvent<SVGElement>) => {
        const target = e.target as HTMLElement;
        if (target.classList.contains('disabled')) return;
        if (!selectedObstruction) {
            sceneViewer.viewerAlert({
                title: "Select obstruction to delete",
                messageType: AlertType.warning,
                isCloseAfterDisplay: true,
                autoCloseSeconds: 2000,
            });
            return;
        }
        sceneViewer.addStep(EditAction.GhostObstruction, selectedObstruction.obstId, "", selectedObstruction.obstId);
        sceneViewer.setObstDelete();
    }

    const setObstType = (num: number) => {
        let oldValue = selectedObstruction?.shapeNum;
        sceneViewer.setObstShape(num);
        sceneViewer.addStep(EditAction.ObstShape, selectedObstruction?.obstId, oldValue, num);
    }

    const onClickCopy = (e: React.MouseEvent<SVGElement>) => {
        const target = e.target as HTMLElement
        if (target.classList.contains('disabled')) return;
        sceneViewer.setPushMode(true, true);
        useViewerStore.setState({isAddObstructionActive: true});
    }


    const onChangeHideAllGhostObstructions = () => {
        useViewerStore.setState({isHideAllGhostObstructions: !isHideAllGhostObstructions});
        sceneViewer.hideObject(HideObjectType.GhostObst, !isHideAllGhostObstructions);
    }

    const onSliderChangeComplete = (selectType: EditAction, value: number, oldValue: number) => {
        if (!selectedObstruction) return;
        const originalValueArr = [], newValueArr = [];
        if (selectType === EditAction.ObstSides) {
            originalValueArr.push(oldValue);
            newValueArr.push(value);
        } else {
            originalValueArr.push(convertQuantityToUnit(oldValue, obstructionUnit, METER));
            newValueArr.push(convertQuantityToUnit(value, obstructionUnit, METER));
        }

        sceneViewer.addStep(selectType, selectedObstruction.obstId, originalValueArr, newValueArr);
        sceneViewer.refreshShade();

    }

    const isObstSelected = () => {
        if(selectedObstruction === undefined){
            alert("Please select an obstruction");
        }
    }

    const isObstOnRoof = () => {
        if(selectedObstruction !== undefined &&
            (selectedObstruction.roofId)){
            return true;
        }
        else{
            return false;
        }
    }

    return (
        user ?
            <div className='tab__inner'>
                <div className='tab__title'>
                    <span className='tab__title--text'>Obstruction</span>
                    {hasCapability('Edit_Obstruction_Remove') ? (
                        <div className='tab__title--btns'>
                            <FiCopy onClick={onClickCopy}/>
                            <FiTrash2
                                title={'Ghost Obstruction'}
                                onClick={setDeleteObst}/>
                        </div>
                    ) : null}
                </div>
                <div className='tab__column'>
                    <Flex align='center' justify='center' gap={15}>
                        {hasCapability('Edit_Obstruction_Add') &&
                            <Button
                                ref={registerRef('addObstBtn')}
                                icon={<Plus size={18}/>}
                                className={`${isAddObstructionActive ? 'active' : ''}`}
                                id='addObstBtn'
                                type='default'
                                size='middle'
                                onClick={() => selectMethod('add')}
                            >Add</Button>
                        }

                        {hasCapability('Edit_Obstruction_Move') &&
                            <Button
                                ref={registerRef('moveObstBtn')}
                                icon={<ArrowsOutCardinal size={18}/>}
                                className={`${isMoveObstructionActive ? 'active' : ''}`}
                                id='moveObstBtn'
                                type='default'
                                size='middle'
                                onClick={() => selectMethod('move')}
                            >Move</Button>
                        }
                    </Flex>
                </div>
                {
                    <div className={`tab__column ${!selectedObstruction && 'disabled'}`}>
                        <div
                            className={hasCapability('Edit_Obstruction_Modify_Size') ? "tab__column obst-edit-mask" : 'tab__column obst-edit-mask disabled'}>
                            <span className='tab__column--title'>Obstruction Type</span>
                            <Splide
                                options={{
                                    rewind: false,
                                    width: '100%',
                                    gap: '10px',
                                    perPage: 3,
                                    perMove: 1,
                                }}
                            >
                                {obstructions.map((item) => {
                                    return (
                                        <SplideSlide key={item.id}>
                                            <Button 
                                                    className={`carousel__img btn-obst-type btnObstType${item.id}`}
                                                    onClick={() => setObstType(item.id)}>
                                                <img src={item.img} alt={item.alt} title={item.alt}/>
                                            </Button>
                                        </SplideSlide>
                                    )
                                })}
                            </Splide>
                        </div>

                        <div
                            className={hasCapability('Edit_Obstruction_Modify_Size') ? "tab__column obst-edit-mask" : 'tab__column obst-edit-mask disabled'}>
                            <span className="tab__column--subtitle">Height</span>
                            <SliderInput
                                settings={rangeCubeHeight}
                                value={cubeHeight}
                                unit={renderUnit(obstructionUnit)}
                                onChange={changeCubeHeight}
                                onChangeComplete={(value, oldVal) => onSliderChangeComplete(EditAction.ObstHeight, value, oldVal)}
                            />

                            <span className='tab__spacer'></span>
                        </div>
                        {/* Rectangle Column - hide and show when the rectangle toggled */}
                        <div
                            className={hasCapability('Edit_Obstruction_Modify_Size') ? "tab__column obst-edit-mask" : 'tab__column obst-edit-mask disabled'}
                            id='obstControlCube'>
                            <span className="tab__column--title">Rectangle Properties</span>
                            <span className="tab__column--subtitle">Length</span>
                            <SliderInput
                                settings={rangeCubeLength}
                                value={length}
                                unit={renderUnit(obstructionUnit)}
                                onChange={changeLength}
                                onChangeComplete={(value, oldVal) => onSliderChangeComplete(EditAction.ObstLength, value, oldVal)}
                            />

                            <span className="tab__column--subtitle">Breadth</span>

                            <SliderInput
                                settings={rangeCubeWidth}
                                value={width}
                                unit={renderUnit(obstructionUnit)}
                                onChange={changeWidth}
                                onChangeComplete={(value, oldVal) => onSliderChangeComplete(EditAction.ObstWidth, value, oldVal)}
                            />

                        </div>
                        {/* Polygonal Column - hide and show when the polygonal toggled */}
                        <div
                            className={hasCapability('Edit_Obstruction_Modify_Size') ? "tab__column obst-edit-mask" : 'tab__column obst-edit-mask disabled'}
                            id='obstControlPolygon'>
                            <span className="tab__column--title">Polygon Properties</span>
                            <span className="tab__column--subtitle">Number of Sides</span>
                            <SliderInput
                                settings={rangePolygonSides}
                                value={sides}
                                unit={renderUnit(obstructionUnit)}
                                onChange={changeSides}
                                onChangeComplete={(value, oldVal) => onSliderChangeComplete(EditAction.ObstSides, value, oldVal)}
                            />
                            <span className="tab__column--subtitle">Breadth</span>

                            <SliderInput
                                settings={rangeCircleRadius}
                                value={diameter}
                                unit={renderUnit(obstructionUnit)}
                                onChange={changeDiameter}
                                onChangeComplete={(value, oldVal) => onSliderChangeComplete(EditAction.ObstDiameter, value, oldVal)}
                            />
                        </div>
                        {/* Circular Column - hide and show when the circular toggled */}
                        <div
                            className={hasCapability('Edit_Obstruction_Modify_Size') ? "tab__column obst-edit-mask" : 'tab__column obst-edit-mask disabled'}
                            id='obstControlCyliner'>
                            <span className="tab__column--title">Circle Properties</span>
                            <span className="tab__column--subtitle">Radius</span>

                            <SliderInput
                                settings={rangeCircleRadius}
                                value={radius}
                                unit={renderUnit(obstructionUnit)}
                                onChange={changeRadius}
                                onChangeComplete={(value, oldVal) => onSliderChangeComplete(EditAction.ObstRadius, value, oldVal)}
                            />
                        </div>

                        {/* Toggle Obstruction */}


                        {
                            hasCapability('Toggle_Ghost_Obstructions') &&
                            <div
                                className={(hasCapability('Toggle_Ghost_Obstructions') && isObstOnRoof()) ? "tab__column obst-edit-mask" : 'tab__column obst-edit-mask disabled'}>
                                <span className="tab__column--subtitle">Toggle Obstruction Direction</span>
                                <div onClick={isObstSelected}>
                                  <Switch labelOne='Parallel' labelTwo='Vertical' property={"ObstVer"}/>  
                                </div>
                                
                                <span className='tab__spacer'></span>
                                
                            </div>
                        }

                    </div>

                }
                <div className='tab__column'>
                    <div className='tab__flex justify-between'>
                        <span className="tab__column--subtitle mb-0">Hide All Ghost Obstructions</span>
                        <Toggle

                            on={isHideAllGhostObstructions}
                            onChange={onChangeHideAllGhostObstructions}
                        />
                    </div>

                    <br />
                    <Alert
                        style={{
                            color: "black"
                        }}
                        message="Toggle this OFF to view the Ghost Obstructions" type="info" showIcon />
                </div>
            </div>
            : <></>
    );
}

export default ObstructionProperties;
